import React, { lazy, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { TemplateValidationResult } from './custom-email/types';

const CustomEmailEditor = lazy(() => import('./custom-email/CustomEmailEditor'));

interface WysiwygEditorProps {
  engine?: string;
  initialHtml?: string;
  onChange?: (html: string) => void;
  onValidationChange?: (result: TemplateValidationResult) => void;
}

const Loading = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
    <CircularProgress size={24} />
  </Box>
);

const WysiwygEditor: React.FC<WysiwygEditorProps> = ({ initialHtml, onChange, onValidationChange }) => {
  const renderEditor = () => (
    <CustomEmailEditor
      initialHtml={initialHtml}
      onChange={onChange}
      onValidationChange={onValidationChange}
    />
  );

  return (
    <Suspense fallback={<Loading />}>
      {renderEditor()}
    </Suspense>
  );
};

export default WysiwygEditor;
